import { useEffect, useState } from 'react';
import {
  isPushSupported,
  getCurrentSubscription,
  subscribePush,
  unsubscribePush,
  sendTestPush,
} from '../pwa/pushClient.js';

// Card pentru Contul meu — gestionează activarea notificărilor push.
export function NotificationsBox() {
  const [supported, setSupported] = useState(false);
  const [permission, setPermission] = useState('default');
  const [subscribed, setSubscribed] = useState(false);
  const [busy, setBusy] = useState(false);
  const [msg, setMsg] = useState('');
  const [err, setErr] = useState('');

  async function refreshState() {
    const sup = isPushSupported();
    setSupported(sup);
    if (!sup) return;
    setPermission(Notification.permission);
    try {
      const sub = await getCurrentSubscription();
      setSubscribed(Boolean(sub));
    } catch {
      setSubscribed(false);
    }
  }

  useEffect(() => { refreshState(); }, []);

  async function handleActivate() {
    setErr(''); setMsg(''); setBusy(true);
    try {
      const r = await subscribePush();
      if (r.subscribed) {
        setMsg('Notificări activate. Vei primi alerte chiar și cu aplicația închisă.');
        await refreshState();
      } else if (r.reason === 'permission_denied') {
        setErr('Ai refuzat permisiunea pentru notificări. Poți schimba decizia din setările browserului.');
      } else if (r.reason === 'not_supported') {
        setErr('Browserul tău nu suportă notificări push. Pe iPhone: instalează aplicația din meniul „Share → Add to Home Screen".');
      } else {
        setErr('Eroare: ' + r.reason);
      }
    } catch (ex) {
      setErr('Eroare: ' + (ex.body?.error || ex.message));
    } finally {
      setBusy(false);
    }
  }

  async function handleDeactivate() {
    setErr(''); setMsg(''); setBusy(true);
    try {
      await unsubscribePush();
      setMsg('Notificări dezactivate.');
      await refreshState();
    } catch (ex) {
      setErr('Eroare: ' + (ex.body?.error || ex.message));
    } finally {
      setBusy(false);
    }
  }

  async function handleTest() {
    setErr(''); setMsg(''); setBusy(true);
    try {
      const r = await sendTestPush();
      if (r.sent > 0) setMsg(`Notificare de test trimisă (${r.sent} dispozitive).`);
      else setMsg('Nicio subscripție activă. Activează mai întâi notificările.');
    } catch (ex) {
      setErr('Eroare: ' + (ex.body?.error || ex.message));
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="card space-y-3">
      <div>
        <h3 className="text-base font-semibold text-ink">Notificări push</h3>
        <p className="mt-1 text-xs text-muted">
          Primește notificări pe telefon/desktop când documentele tale sunt aproape să expire, chiar dacă aplicația e închisă.
        </p>
      </div>

      {msg && <div className="rounded-lg border border-ok/30 bg-ok/10 px-3 py-2 text-sm text-ok">{msg}</div>}
      {err && <div className="rounded-lg border border-danger/30 bg-danger/10 px-3 py-2 text-sm text-danger">{err}</div>}

      {!supported ? (
        <div className="rounded-lg border border-warn/30 bg-warn/5 px-3 py-2 text-sm text-warn">
          Browserul actual nu suportă notificări. Pe iPhone: instalează aplicația din meniul Safari „Share → Add to Home Screen" și revin aici.
        </div>
      ) : permission === 'denied' ? (
        <div className="rounded-lg border border-danger/30 bg-danger/10 px-3 py-2 text-sm text-danger">
          Ai refuzat permisiunea. Activează din setările browserului (sita / iconiță lacăt în bara de adrese) și reîncarcă pagina.
        </div>
      ) : subscribed ? (
        <div className="flex flex-wrap gap-2">
          <span className="inline-flex items-center gap-2 rounded-lg border border-ok/30 bg-ok/10 px-3 py-2 text-sm font-semibold text-ok">
            ✓ Notificări activate pe acest dispozitiv
          </span>
          <button onClick={handleTest} disabled={busy} className="btn-ghost border border-border text-sm">
            Trimite test
          </button>
          <button onClick={handleDeactivate} disabled={busy} className="btn-ghost text-sm text-danger hover:bg-danger/10">
            Dezactivează
          </button>
        </div>
      ) : (
        <button onClick={handleActivate} disabled={busy} className="btn-primary w-full">
          {busy ? 'Se activează…' : 'Activează notificări push'}
        </button>
      )}
    </div>
  );
}
